import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FaqsPageComponent } from './page/faqs-page/faqs-page.component';

const routes: Routes = [
  {
    path: '',
    component :FaqsPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FaqRoutingModule { }
